import Vue from 'vue'
import Vuex from 'vuex'

import toast from './toast'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    width: window.innerWidth,
    top: window.pageYOffset || document.documentElement.scrollTop
  },

  mutations: {
    setWidth (state, width) {
      state.width = width
    },

    setTop (state, top) {
      state.top = top
    }
  },

  modules: {
    toast
  }
})
